import RecommendedSection from "../recommendedSection";
const RecommendedForYouSection = () => {
  return(
    <div className="md:-mt-20">
    <RecommendedSection/>
    </div>
  )
};

export default RecommendedForYouSection;